import React, { useState, useEffect } from "react";

import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import AddOwner from "../../../../modals/yourAssets/BOA/CustomSubOwnersModal";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import AddCircleOutlineSharpIcon from "@mui/icons-material/AddCircleOutlineSharp";
import {
  deleteInsuranceDocument,
  getInsuranceDocument,
  updateUserInsurance,
  uploadInsuranceDocuement,
} from "../../../../services/yourAssets/InsuranceServices";
import { SecondaryButton } from "../../../../common/Buttons";
import { IconButton } from "@mui/material";
import { Box } from "@mui/system";
import {
  insuranceSubOwnerInitialValues,
  insuranceFields,
  insuranceFieldsValidationSchema,
} from "../../../../modals/yourAssets/BOA/helper";
import DeleteDataModal from "../../../../modals/yourAssets/BOA/DeleteDataModal";
import toast from "react-hot-toast";
import { Circles } from "react-loader-spinner";

import SimpleBarReact from "simplebar-react";
import "./../BOA.scss";
import ImportData from "../ImportData";
import {
  getDateFromDateStamp,
  getKeyFromText,
  getTimeFromDateStamp,
  getUserIdFromLocalStorage,
  changeUpdateFormat,
} from "../../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import { updateAuditTrails } from "../../../../services/auditTrails";
import ModifiedByToaster from "../../../../common/ModifiedByToaster";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllUsersBA,
  getFile,
  updateUserBA,
} from "../../../../services/yourAssets/BankBalancesServices";
import FilePreviewModal from "../FilePreviewModal";
import DeleteFileModal from "../../../../modals/yourAssets/BOA/DeleteFileModal";
import { handleReloadFiles } from "../../../../redux/slices/yourAssets/AssetsDocumentsSlice";
import {
  deleteUserMediaBOA,
  getUserMediaBOA,
} from "../../../../services/yourAssets/CommonServices";
const Summary = ({
  next,
  summaryValues,
  handleSetSummaryValues,
  disableContinueButton,
  updatedIds,
  auditTrailIds,
  updatesList,
}) => {
  const dispatch = useDispatch();
  let uID = getUserIdFromLocalStorage();
  let currentConsultantId = localStorage.getItem("currentConsultantId");
  const { t, i18n } = useTranslation();
  const [showSubOwnersModal, setShowSubOwnersModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [selectedSubOwnerIndex, setSelectedSubOwnerIndex] = useState(-1);
  const [insuranceDocument, setInsuranceDocument] = useState("");
  const [insuranceType, setInsuranceType] = useState("");
  const [insuranceDocumentName, setInsuranceDocumentName] = useState("");
  const [continueButton, setContinueButton] = useState(disableContinueButton);
  const [newFlow, setNewFlow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [deleteDocumentObject, setDeleteDocumentObject] = useState({});
  const [userType, setUserType] = useState("");
  const documentList = useSelector(
    (state) => state.assetsDocuments.documents.insurances
  );
  const [fileStream, setFileStream] = useState("");
  const [fileName, setFileName] = useState("");
  const [previewDocument, setPreviewDocument] = useState(false);
  const [focusedDocument, setFocusedDocument] = useState({});
  const [isDeletingFile, setIsDeletingFile] = useState(false);
  let colorToggle = true;

  const [initialValues, setInitialValues] = useState(null);
  const [deleteDocumentModal, setDeleteDocumentModal] = useState(false);
  const handleUpdates = async (data) => {
    const result = await updateAuditTrails(data, currentConsultantId);
  };
  useEffect(() => {
    handleUpdates(auditTrailIds);
  }, []);

  const enabledTypes = [
    {
      insuranceId: "b63a13ec-5fa8-421d-b106-0088626399e6",
      name: t("i-type-5"),
      type: 2,
    },
    {
      insuranceId: "f901067d-da0c-45f9-b680-6a6e68874ea7",
      name: t("i-type-7"),
      type: 2,
    },
    {
      insuranceId: "5e4c1ffa-f9cb-45ce-86ad-f3a879e5118c",
      name: t("i-type-8"),
      type: 2,
    },
    {
      insuranceId: "70206929-d962-4071-b737-8630ce38a1a2",
      name: t("i-type-9"),
      type: 2,
    },
  ];
  const disabledTypes = [
    {
      insuranceId: "ccfed019-f7b5-4beb-8e43-fe971e5dbefa",
      name: t("i-type-6"),
      type: 2,
    },

    {
      insuranceId: "9d46753c-e9a2-4793-be30-acaf933d0e65",
      name: t("i-type-1"),
      type: 1,
    },

    {
      insuranceId: "4121e60e-3984-48ee-bc37-3d6356207ed5",
      name: t("i-type-2"),
      type: 1,
    },
    {
      insuranceId: "6d8460e5-4654-4b67-aca2-29dc5bee8048",
      name: t("i-type-3"),
      type: 1,
    },
    {
      insuranceId: "bc750d11-36ee-4123-a6b5-c7fa44ba2c6d",
      name: t("i-type-4"),
      type: 1,
    },
  ];
  const postUserInsurance = async () => {
    setBtnLoading(true);
    const payLoad = [];
    summaryValues
      ?.filter((el) => enabledTypes.some((type) => type.insuranceId === el.id))
      .forEach((el) => {
        let obj = {
          insuranceId: el.userInsuranceId ? el.userInsuranceId : "",
          insuranceCategoryId: el.id,
          insuranceHolder: el.owner?.name,
          insuredPerson: el.owner?.insuredPerson,
          beneficiaries: el.owner?.beneficiary,
          buyBackValue: el.owner?.value,
          deathBenefit: el.owner?.deathBenifit,
          documentName: el.owner?.documentName ? el.owner.documentName : "",
          documentId: el.owner?.documentId ? el.owner.documentId : "",
          subInsurances: el.owner?.subOwners?.map((item) => {
            return {
              insuranceId: item.userInsuranceDetailId
                ? item.userInsuranceDetailId
                : "",
              subInsuranceId: item.subInsuranceDetail
                ? item.subInsuranceDetail
                : "",
              insuranceHolder: item.name,
              insuredPerson: item.insuredPerson,
              beneficiaries: item.beneficiary,
              buyBackValue: item.value,
              deathBenefit: item.deathBenifit,
              documentName: item.documentName ? item.documentName : "",
              documentId: item.documentId ? item.documentId : "",
            };
          }),
        };

        payLoad.push(obj);
      });
    summaryValues
      ?.filter((el) => disabledTypes.some((type) => type.insuranceId === el.id))
      .forEach((el) => {
        let obj = {
          insuranceId: el.userInsuranceId ? el.userInsuranceId : "",
          insuranceCategoryId: el.id,
          insuranceHolder: "",
          insuredPerson: "",
          beneficiaries: "",
          buyBackValue: "",
          deathBenefit: "",
          documentName: el.owner?.documentName ? el.owner?.documentName : "",
          documentId: el.owner?.documentId ? el.owner?.documentId : "",
          subInsurances: [],
        };

        payLoad.push(obj);
      });
    try {
      let apiResult = await updateUserInsurance(payLoad, uID);
      if (apiResult?.success) {
        next();
        // toast.success(t(getKeyFromText(apiResult?.message)));
      } else {
        toast.error(t(getKeyFromText(apiResult?.message)));
      }
    } catch (e) {
      console.log(e);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleAddOwner = async (values) => {
    let result;
    if (insuranceDocument) {
      let formData = new FormData();
      formData.append("InsuranceDocument", insuranceDocument);
      setButtonLoader(true);
      result = await uploadInsuranceDocuement(formData, uID);

      if (result?.success) {
        setButtonLoader(false);
        handleSubOwnersModalClose();
        setInsuranceDocument("");
        setInsuranceType("");
      } else {
        setButtonLoader(false);
        handleSubOwnersModalClose();
        toast.error(t(getKeyFromText(result?.message).replaceAll(".", "")));
      }
    } else {
      handleSubOwnersModalClose();
      setInsuranceType("");
    }
    if (selectedRow?.type === "owner") {
      if (selectedRow.behaviour === "create") {
        handleSetSummaryValues(
          summaryValues?.map((item) => {
            if (item.id === selectedRow.id)
              return {
                ...item,
                owner: {
                  ...values,
                  documentId: result?.payLoad?.insuranceDocumentId,
                  documentName: result?.payLoad?.originalFilename,
                  id: "id" + new Date().getTime(),
                },
              };
            return { ...item };
          }) || []
        );
      } else {
        handleSetSummaryValues(
          summaryValues?.map((item) => {
            if (item.id === selectedRow?.id)
              return {
                ...item,
                owner: {
                  ...item.owner,
                  documentId: result
                    ? result?.payLoad?.insuranceDocumentId
                    : item.owner.documentId,
                  documentName: result
                    ? result?.payLoad?.originalFilename
                    : item.owner.documentName,
                  ...values,
                },
              };
            return { ...item };
          }) || []
        );
      }
    } else {
      if (selectedRow.behaviour === "create") {
        handleSetSummaryValues(
          summaryValues?.map((item) => {
            if (item.id === selectedRow?.id)
              return {
                ...item,
                owner: {
                  ...item.owner,
                  subOwners: item.owner?.subOwners
                    ? [
                        ...item.owner.subOwners,
                        {
                          ...values,
                          documentId: result?.payLoad?.insuranceDocumentId,
                          documentName: result?.payLoad?.originalFilename,
                          id: "id" + new Date().getTime(),
                        },
                      ]
                    : [
                        {
                          ...values,
                          documentId: result?.payLoad?.insuranceDocumentId,
                          documentName: result?.payLoad?.originalFilename,
                          id: "id" + new Date().getTime(),
                        },
                      ],
                },
              };
            return { ...item };
          }) || []
        );
      } else {
        handleSetSummaryValues(
          summaryValues?.map((item) => {
            if (item.id === selectedRow.id)
              return {
                ...item,
                owner: {
                  ...item.owner,
                  subOwners: item?.owner?.subOwners?.map((subowner, index) => {
                    if (initialValues.id === subowner.id) {
                      return {
                        ...values,
                        documentId: result
                          ? result?.payLoad?.insuranceDocumentId
                          : subowner.documentId,
                        documentName: result
                          ? result?.payLoad?.originalFilename
                          : subowner.documentName,
                      };
                    }
                    return subowner;
                  }),
                },
              };
            return { ...item };
          }) || []
        );
      }
    }
    result = "";
    setInsuranceDocument("");
    setInsuranceDocumentName("");
    setContinueButton(false);
  };
  const selectInsuranceDocument = (e) => {
    let file = e.target.files[0];
    let fSExt = new Array("Bytes", "KB", "MB", "GB");
    let _size = file.size;
    let i = 0;
    while (_size > 900) {
      _size /= 1024;
      i++;
    }
    let exactSize = Math.round(_size * 100) / 100;
    let exactExt = fSExt[i];
    if ((exactSize > 60 && exactExt === "MB") || exactExt === "GB") {
      toast.error(t("file-size-must-be-less-than-60-mbs"));
    } else {
      setInsuranceDocument(file);
      setInsuranceDocumentName(file.name);
    }
  };

  const deleteDocument = async (type, object) => {
    setNewFlow(true);
    if (object.documentName) {
      setShowDeleteModal(true);
    }
    setDeleteDocumentObject(object);
    setInsuranceDocumentName(object.documentName);

    if (type === "owner") {
      setUserType("owner");
    } else {
      setUserType("");
      e;
    }
  };
  const downloadInsuranceDocument = async (documentId, documentName) => {
    const result = await getInsuranceDocument(uID, documentId, documentName);
  };
  const handleDeleteDocument = async () => {
    setIsLoading(true);
    if (userType === "owner") {
      let { documentId, id } = deleteDocumentObject;
      let result = await deleteInsuranceDocument(documentId, uID);
      if (result.success === "success") setShowDeleteModal(false);
      for (let i = 0; i < summaryValues.length; i++) {
        const elementI = summaryValues[i];
        if (elementI.owner?.id === id) {
          elementI.owner.documentId = "";
          elementI.owner.documentName = "";
        }
      }
    } else {
      let { documentId, subInsuranceDetail } = deleteDocumentObject;
      let result = await deleteInsuranceDocument(documentId);
      if (result.success === "success") setShowDeleteModal(false);
      for (let i = 0; i < summaryValues.length; i++) {
        const elementI = summaryValues[i];
        for (let j = 0; j < elementI.owner.subOwners.length; j++) {
          const elementJ = elementI.owner.subOwners[j];
          if (elementJ.subInsuranceDetail === subInsuranceDetail) {
            elementJ.documentId = "";
            elementJ.documentName = "";
          }
        }
      }
    }
    handleSetSummaryValues([...summaryValues]);
    setIsLoading(false);
  };

  const handleDeleteOwner = (type, id, subIndex) => {
    if (type === "owner") {
      handleSetSummaryValues(
        summaryValues?.filter((item, index) => item.id !== selectedRow?.id)
      );
    } else {
      handleSetSummaryValues(
        summaryValues?.map((item, itemIndex) => {
          if (item.id === id)
            return {
              ...item,
              owner: {
                ...item.owner,
                subOwners: item.owner.subOwners.filter(
                  (subOwner, index) => index !== subIndex
                ),
              },
            };
          return item;
        })
      );
    }
  };

  const handleSubOwnersModalOpen = () => {
    setShowSubOwnersModal(true);
  };

  const handleSubOwnersModalClose = () => {
    setShowSubOwnersModal(false);
    setSelectedRow(null);
    setInsuranceType("");
  };

  const handleSetSelectedRow = (
    item,
    type,
    behaviour = "create",
    insuredPerson
  ) => {
    setSelectedRow({
      ...item,
      name: t(getKeyFromText(item.name)),
      type,
      behaviour,
      insuredPerson,
    });
  };

  const totalCountBuyBack = () => {
    let count = 0;

    summaryValues
      ?.filter((item) =>
        enabledTypes.some((type) => type.insuranceId === item.id)
      )
      .forEach((item) => {
        if (item?.owner) {
          count += item.owner?.value ? +item.owner.value : 0;
          // if (item.owner?.subOwners?.length > 0) {
          //   item.owner.subOwners.forEach((el) => {
          //     count += el?.value ? +el.value : 0;
          //   });
          //}
        }
      });
    return count.toLocaleString("de-DE");
  };
  const totalCountDeathBenifit = () => {
    let count = 0;

    summaryValues
      ?.filter((item) =>
        enabledTypes.some((type) => type.insuranceId === item.id)
      )
      .forEach((item) => {
        if (item?.owner) {
          count += item.owner?.deathBenifit ? +item.owner.deathBenifit : 0;
          // if (item.owner?.subOwners?.length > 0) {
          //   item.owner.subOwners.forEach((el) => {
          //     count += el?.deathBenifit ? +el.deathBenifit : 0;
          //   });
          // }
        }
      });
    return count.toLocaleString("de-DE");
  };

  const getInitialValues = () => {
    if (initialValues !== null) {
      return {
        name: initialValues.name,
        insuredPerson: initialValues.insuredPerson,
        beneficiary: initialValues.beneficiary,
        value: initialValues.value,
        deathBenifit: initialValues.deathBenifit,
      };
    }
    return insuranceSubOwnerInitialValues;
  };
  const handleRemoveFile = (obj) => {
    setFocusedDocument(obj);
    setDeleteDocumentModal(true);
  };
  const handleClosePreviewModal = () => {
    setPreviewDocument(false);
    setFocusedDocument("");
    setFileStream("");
  };
  const handleCloseDeleteModal = () => {
    setDeleteDocumentModal(false);
  };
  const handleViewFile = async (document) => {
    const { boaUserMediaFileId, originalFilename } = document;
    setFileName(originalFilename);
    const result = await getFile({
      userId: uID,
      boaMediaId: boaUserMediaFileId,
    });
    if (result?.payLoad) {
      setFileStream(result.payLoad);
      setPreviewDocument(true);
      setFocusedDocument(document);
    }
  };
  const handleDeleteFile = async () => {
    setIsDeletingFile(true);
    const { boaUserMediaFileId } = focusedDocument;
    const result = await deleteUserMediaBOA(uID, boaUserMediaFileId);
    if (result?.success) {
      // toast.success(
      //   t(
      //     result?.message
      //       .toLowerCase()
      //       .replaceAll(" ", "-")
      //       .replaceAll("/", "-")
      //       .replaceAll(",", "")
      //       .replaceAll("'", "")
      //   )
      // );
      handleCloseDeleteModal();
      handleClosePreviewModal();
      dispatch(handleReloadFiles());
      setIsDeletingFile(false);
    }
  };

  const handleDeleteModalShow = () => setDeleteDocumentModal(true);
  return (
    <>
      {showSubOwnersModal && (
        <AddOwner
          open={showSubOwnersModal}
          handleOpen={handleSubOwnersModalOpen}
          handleClose={handleSubOwnersModalClose}
          handleDelete={handleDeleteOwner}
          handleSubmit={handleAddOwner}
          type={selectedRow && selectedRow.type}
          id={selectedRow && selectedRow.id}
          selectedRow={selectedRow ? selectedRow : null}
          getInitialValues={getInitialValues}
          enteries={insuranceFields(t)}
          validationSchema={insuranceFieldsValidationSchema(t)}
          tabName="insurance"
          selectInsuranceDocument={selectInsuranceDocument}
          documentName={insuranceDocumentName}
          btnLoader={buttonLoader}
          insuranceType={insuranceType}
        />
      )}
      {showDeleteModal && (
        <DeleteDataModal
          open={showDeleteModal}
          handleClose={() => {
            setShowDeleteModal(false);
          }}
          accountTypeId={selectedRow?.id}
          user={t(selectedRow?.translationKey) || insuranceDocumentName}
          setIsLoading={setIsLoading}
          deleteData={() =>
            handleDeleteOwner(
              selectedRow?.type,
              selectedRow?.id,
              selectedSubOwnerIndex
            )
          }
          newFlow={newFlow}
          handleDelete={handleDeleteDocument}
          isLoading={isLoading}
        />
      )}

      <Box className="insurance-container" position="relative">
        <Box className="table-n-btns-wrapper">
          <Box
            className="upload-add-btn-wrapper"
            component="div"
            sx={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <ImportData
              sectionId={4}
              documentList={documentList}
              handleRemoveFile={handleRemoveFile}
              handleViewFile={handleViewFile}
            />
          </Box>
          {/* <SimpleBarReact style={{ maxHeight: 300 }} autoHide={false}> */}
          <TableContainer component={Paper} className="summary-table">
            <Table
              sx={{
                "th , td": { border: "none" },
              }}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    align="left"
                    sx={{
                      width: "200px",
                      backgroundColor: "#f8f8f8 !important",
                    }}
                  >
                    {t("common-table-heading-5")}
                  </TableCell>
                  <TableCell align="left">{t("i-table-heading-2")} </TableCell>
                  <TableCell align="left">{t("i-table-heading-3")}</TableCell>
                  <TableCell align="left">{t("i-table-heading-4")}</TableCell>
                  <TableCell align="left">{t("i-table-heading-5")}</TableCell>
                  <TableCell align="left">{t("i-table-heading-6")}</TableCell>
                  <TableCell align="left">{t("i-table-heading-7")}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <>
                  {summaryValues?.map((item, index) =>
                    enabledTypes.some(
                      (type) => type.insuranceId === item.id
                    ) ? (
                      <>
                        <TableRow
                          sx={{
                            backgroundColor: `${
                              colorToggle ? "#dfc8db40" : "#dfc8db95"
                            }`,
                          }}
                          className={`main-rows ${
                            updatedIds.includes(item?.userInsuranceId)
                              ? "highlighted-table-row"
                              : ""
                          }`}
                        >
                          <TableCell>
                            {item?.translationKey
                              ? t(item?.translationKey)
                              : "-"}
                          </TableCell>
                          <TableCell>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              {item?.owner?.name ? (
                                <>
                                  {item.owner.name}{" "}
                                  {
                                    <IconButton
                                      sx={{
                                        cursor: "pointer",
                                      }}
                                      aria-label="Add"
                                      size="small"
                                      onClick={() => {
                                        setInitialValues({
                                          name: item.owner.name,
                                          insuredPerson: "",
                                          beneficiary: "",
                                          value: "",
                                          deathBenifit: "",
                                        });
                                        handleSetSelectedRow(
                                          item,
                                          "subOwner",
                                          "create"
                                        );
                                        handleSubOwnersModalOpen();
                                        setInsuranceDocumentName("");
                                      }}
                                    >
                                      <AddCircleOutlineSharpIcon />
                                    </IconButton>
                                  }
                                </>
                              ) : (
                                "-"
                              )}
                            </Box>
                          </TableCell>
                          <TableCell>
                            {item?.owner?.insuredPerson
                              ? item.owner.insuredPerson
                              : "-"}
                          </TableCell>
                          <TableCell>
                            {item.owner?.beneficiary
                              ? item.owner?.beneficiary
                              : "-"}
                          </TableCell>
                          <TableCell>
                            {item?.owner?.value
                              ? Number(item.owner?.value).toLocaleString(
                                  "de-DE"
                                ) + " €"
                              : "-"}
                          </TableCell>
                          <TableCell>
                            {item?.owner?.deathBenifit
                              ? Number(item.owner?.deathBenifit).toLocaleString(
                                  "de-DE"
                                ) + " €"
                              : "-"}
                          </TableCell>
                          <TableCell
                            onClick={(e) => {
                              e.stopPropagation();
                              // deleteDocument("owner", item.owner);
                              downloadInsuranceDocument(
                                item.owner.documentId,
                                item.owner.documentName
                              );
                            }}
                            style={{
                              cursor: "pointer",
                            }}
                          >
                            {item?.owner?.documentName
                              ? item.owner?.documentName
                              : "-"}
                          </TableCell>

                          <TableCell>
                            {item?.owner?.name ? (
                              <>
                                <IconButton
                                  sx={{
                                    cursor: "pointer",
                                  }}
                                  aria-label="add"
                                  size="small"
                                  onClick={() => {
                                    handleSetSelectedRow(item, "owner", "edit");
                                    setInitialValues(item.owner);
                                    handleSubOwnersModalOpen();
                                    setInsuranceDocumentName(
                                      item.owner.documentName
                                    );
                                  }}
                                >
                                  <img
                                    src="/assets/icons/edit-icon.svg"
                                    alt="edit"
                                  />
                                </IconButton>
                                <IconButton
                                  sx={{
                                    cursor: "pointer",
                                  }}
                                  aria-label="delete"
                                  size="small"
                                  onClick={() => {
                                    handleSetSelectedRow(
                                      item,
                                      "owner",
                                      "",
                                      item.owner.insuredPerson
                                    );
                                    setNewFlow(false);
                                    setShowDeleteModal(true);
                                  }}
                                >
                                  <img
                                    src="/assets/icons/delete-icon.svg"
                                    alt="delete"
                                  />
                                </IconButton>
                              </>
                            ) : (
                              <>
                                <IconButton
                                  sx={{
                                    cursor: "pointer",
                                    margin: "0 auto",
                                  }}
                                  aria-label="Add"
                                  size="small"
                                  onClick={() => {
                                    setInitialValues(null);
                                    handleSetSelectedRow(
                                      item,
                                      "owner",
                                      "create"
                                    );
                                    handleSubOwnersModalOpen();
                                  }}
                                >
                                  <img
                                    src="/assets/icons/edit-icon.svg"
                                    alt="edit"
                                  />
                                </IconButton>
                                <IconButton
                                  sx={{
                                    cursor: "pointer",
                                  }}
                                  aria-label="delete"
                                  size="small"
                                  onClick={() => {
                                    handleSetSelectedRow(item, "owner", "", "");
                                    setShowDeleteModal(true);
                                    setNewFlow(false);
                                  }}
                                >
                                  <img
                                    src="/assets/icons/delete-icon.svg"
                                    alt="delete"
                                  />
                                </IconButton>
                              </>
                            )}
                          </TableCell>
                        </TableRow>
                        {item?.owner?.subOwners?.length > 0 &&
                          item.owner.subOwners?.map((owner, ownerIndex) => {
                            return (
                              <TableRow
                                key={ownerIndex}
                                sx={{
                                  backgroundColor: `${
                                    colorToggle ? "#dfc8db" : "#dfc8db95"
                                  }`,
                                }}
                              >
                                <TableCell />
                                <TableCell></TableCell>
                                <TableCell>{owner.insuredPerson}</TableCell>
                                <TableCell>{owner.beneficiary}</TableCell>
                                <TableCell>
                                  {Number(owner.value).toLocaleString("de-DE") +
                                    " €"}
                                </TableCell>
                                <TableCell>
                                  {Number(owner.deathBenifit).toLocaleString(
                                    "de-DE"
                                  ) + " €"}
                                </TableCell>
                                <TableCell
                                  onClick={() => {
                                    // deleteDocument("subOwner", owner);
                                    downloadInsuranceDocument(
                                      owner.documentId,
                                      owner.documentName
                                    );
                                  }}
                                  style={{
                                    cursor: "pointer",
                                  }}
                                >
                                  {owner?.documentName
                                    ? owner?.documentName
                                    : "-"}
                                </TableCell>
                                <TableCell>
                                  <IconButton
                                    sx={{
                                      cursor: "pointer",
                                    }}
                                    aria-label="add"
                                    size="small"
                                    onClick={() => {
                                      handleSetSelectedRow(
                                        item,
                                        "subOwner",
                                        "edit"
                                      );
                                      setInitialValues(owner);
                                      handleSubOwnersModalOpen();
                                      setInsuranceDocumentName(
                                        owner.documentName
                                      );
                                    }}
                                  >
                                    <img
                                      src="/assets/icons/edit-icon.svg"
                                      alt="edit"
                                    />
                                  </IconButton>{" "}
                                  <IconButton
                                    sx={{
                                      cursor: "pointer",
                                    }}
                                    aria-label="delete"
                                    size="small"
                                    onClick={() => {
                                      setSelectedSubOwnerIndex(ownerIndex);
                                      handleSetSelectedRow(
                                        item,
                                        "subOwner",
                                        "",
                                        owner.insuredPerson
                                      );
                                      setShowDeleteModal(true);
                                      setNewFlow(false);
                                    }}
                                  >
                                    <img
                                      src="/assets/icons/delete-icon.svg"
                                      alt="delete"
                                    />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        {(colorToggle = !colorToggle)}
                      </>
                    ) : null
                  )}

                  <TableRow
                    sx={{
                      backgroundColor: `${
                        colorToggle ? "#dfc8db" : "#dfc8dbFF"
                      }`,
                    }}
                  >
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell
                      sx={{ padding: "16px !important" }}
                      align="right"
                    >
                      {t("total")}
                    </TableCell>
                    <TableCell
                      sx={{ paddingLeft: "16px !important" }}
                    >{`${totalCountBuyBack()} € `}</TableCell>
                    <TableCell
                      sx={{ paddingLeft: "16px !important" }}
                    >{`${totalCountDeathBenifit()} € `}</TableCell>
                    <TableCell></TableCell>

                    <TableCell sx={{ background: "white" }}></TableCell>
                  </TableRow>
                  <TableRow sx={{ background: "color.white" }}>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  <TableRow sx={{ background: "color.white" }}>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                  {(colorToggle = true)}
                  {summaryValues?.map((item, index) =>
                    disabledTypes.some(
                      (type) => type.insuranceId === item.id
                    ) ? (
                      <TableRow
                        sx={{
                          backgroundColor: `${
                            colorToggle ? "color.smokeWhite" : "color.white"
                          }`,
                        }}
                        className={`${
                          updatedIds.includes(item?.userInsuranceId)
                            ? "highlighted-table-row"
                            : ""
                        }`}
                      >
                        <TableCell>
                          {item?.translationKey
                            ? t(getKeyFromText(item.translationKey))
                            : "-"}
                        </TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell
                          onClick={(e) => {
                            // deleteDocument("owner", item.owner);
                            e.stopPropagation();
                            downloadInsuranceDocument(
                              item.owner.documentId,
                              item.owner.documentName
                            );
                          }}
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          {item?.owner?.documentName
                            ? item.owner.documentName
                            : "-"}
                        </TableCell>
                        <TableCell
                          sx={{
                            background: "white",
                          }}
                        >
                          {
                            <>
                              <IconButton
                                sx={{
                                  cursor: "pointer",
                                }}
                                aria-label="add"
                                size="small"
                                onClick={() => {
                                  handleSetSelectedRow(item, "owner", "edit");
                                  handleSubOwnersModalOpen();
                                  setInitialValues({
                                    ...item,
                                    insuredPerson: "dummy",
                                    beneficiary: "dummy",
                                    value: 0,
                                    deathBenifit: 0,
                                  });
                                  setInsuranceType("disabled");
                                  setInsuranceDocumentName(
                                    item.owner.documentName
                                  );
                                  setNewFlow(false);
                                }}
                              >
                                <img
                                  src="/assets/icons/edit-icon.svg"
                                  alt="edit"
                                />
                              </IconButton>
                              <IconButton
                                sx={{
                                  cursor: "pointer",
                                }}
                                aria-label="delete"
                                size="small"
                                onClick={() => {
                                  handleSetSelectedRow(item, "owner");
                                  setShowDeleteModal(true);
                                }}
                              >
                                <img
                                  src="/assets/icons/delete-icon.svg"
                                  alt="delete"
                                />
                              </IconButton>
                            </>
                          }
                        </TableCell>
                        {(colorToggle = !colorToggle)}
                      </TableRow>
                    ) : null
                  )}
                  {[1, 2, 3, 4, 5].map((elem, index) => (
                    <TableRow sx={{ background: "color.white" }} key={index}>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  ))}
                </>
              </TableBody>
            </Table>
          </TableContainer>
          {/* </SimpleBarReact> */}
        </Box>
        {/* <Box className="blur-effect" /> */}
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <SecondaryButton
          title={t("save-and-continue")}
          bgColor="color.magentaLight2"
          borderRadius="14px"
          width="200px"
          marginLeft="20px"
          marginTop="40px"
          border="none"
          hoverBgColor="color.magentaLight1"
          textTransform="initial"
          click={() => postUserInsurance()}
          disabled={btnLoading}
        />
      </Box>
      {updatesList?.length > 0 && (
        <ModifiedByToaster
          title={`${t("modified-by")} ${updatesList[0]?.username}` || ""}
          subTitle={` ${changeUpdateFormat(
            updatesList[0]?.updatedTime,
            i18n.language
          )}`}
        />
      )}
      {previewDocument && (
        <FilePreviewModal
          data={fileStream}
          handleClose={handleClosePreviewModal}
          handleDelete={handleDeleteModalShow}
          fileName={fileName}
        />
      )}
      {deleteDocumentModal && (
        <DeleteFileModal
          show={deleteDocumentModal}
          document={focusedDocument}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDeleteFile}
        />
      )}
    </>
  );
};

export default Summary;
